import { useState } from "react";
import { hotLatest, hotTrending, hotHot, type HotItem } from "@/mocks/home";

const tagColor: Record<string, string> = {
  fire: "bg-primary-500 text-background-50",
  new: "bg-accent-500 text-background-50",
  top: "bg-secondary-500 text-background-50",
  normal: "bg-background-200 text-foreground-800",
};

type Feed = { key: string; label: string; data: HotItem[] };
const feeds: Feed[] = [
  { key: "latest", label: "实时热榜", data: hotLatest },
  { key: "hot", label: "全网爆款", data: hotHot },
  { key: "trend", label: "上升趋势", data: hotTrending },
];

const liveComments = [
  { name: "@磕到真的了", text: "三公舞台那个运镜封神了吧，求全场直拍！", tag: "综艺" },
  { name: "@熬夜等路透", text: "路透图都传到第二十张了，蹲个大结局我先", tag: "剧组" },
  { name: "@老粉不请自来", text: "考古一圈发现这剧组细节真的多，越扒越上头", tag: "考古" },
  { name: "@深夜干饭王", text: "弹幕都在玩梗，这瓜田我是一步也迈不开了", tag: "弹幕" },
  { name: "@安静吃瓜", text: "理性说句，生图直出才是最真实的状态，别恶意揣测", tag: "理性" },
  { name: "@同好集合点", text: "暗号对上了，蹲后续的姐妹评论区集合！", tag: "找搭子" },
];

export default function HotSection() {
  const [active, setActive] = useState("latest");
  const feed = feeds.find((f) => f.key === active) ?? feeds[0];

  return (
    <section id="hot" className="relative py-16 md:py-20">
      <div className="container-site">
        <div className="flex flex-col items-start justify-between gap-4 md:flex-row md:items-end">
          <div>
            <span className="text-xs font-bold uppercase tracking-widest text-primary-600">
              Live Hot List
            </span>
            <h2 className="mt-2 text-2xl font-black text-foreground-950 md:text-4xl">
              实时热榜 · 这届网友都在吃
            </h2>
            <p className="mt-2 max-w-xl text-sm text-foreground-600">
              热评、爆料补充、蹲后续一手掌握。点开任意话题加入讨论，同好已经在线等你对暗号。
            </p>
          </div>

          <div className="flex items-center gap-1 rounded-full border border-background-200/70 bg-background-100 p-1">
            {feeds.map((f) => (
              <button
                key={f.key}
                onClick={() => setActive(f.key)}
                className={`whitespace-nowrap rounded-full px-1 py-1 text-sm font-semibold transition ${
                  active === f.key
                    ? "bg-primary-500 text-background-50"
                    : "text-foreground-600 hover:text-foreground-950"
                }`}
              >
                {f.label}
              </button>
            ))}
          </div>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-6 lg:grid-cols-3">
          <div className="lg:col-span-2">
            <ol className="flex flex-col gap-3">
              {feed.data.map((item) => (
                <li key={item.rank}>
                  <a
                    href="#topics"
                    className="group block rounded-xl border border-background-200/70 bg-background-100/60 p-4 transition hover:-translate-y-0.5 hover:border-primary-300 hover:bg-background-100"
                  >
                    <div className="flex items-start gap-4">
                      <span
                        className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-lg text-sm font-black ${
                          item.rank <= 3 ? "bg-primary-500 text-background-50" : "bg-background-200 text-foreground-700"
                        }`}
                      >
                        {item.rank}
                      </span>
                      <div className="min-w-0 flex-1">
                        <div className="flex items-center gap-2">
                          <span className={`rounded-md px-1.5 py-0.5 text-[11px] font-bold ${tagColor[item.tagType]}`}>
                            {item.tag}
                          </span>
                          <span className="text-[11px] text-foreground-600">{item.category}</span>
                          <span className="ml-auto whitespace-nowrap text-[11px] font-semibold text-primary-600 group-hover:text-primary-500">
                            {item.heat} <i className="ri-arrow-right-up-line align-middle"></i>
                          </span>
                        </div>
                        <h3 className="mt-1.5 text-sm font-bold leading-snug text-foreground-950 group-hover:text-primary-700 md:text-base">
                          {item.title}
                        </h3>
                        <p className="mt-1 line-clamp-1 text-xs text-foreground-600">{item.snippet}</p>
                        <div className="mt-2 flex items-center gap-4 text-xs text-foreground-600">
                          <span><i className="ri-chat-3-line mr-1 align-middle"></i>{item.comments} 评论</span>
                          <span><i className="ri-heart-3-line mr-1 align-middle"></i>{item.likes} 点赞</span>
                        </div>
                      </div>
                    </div>
                  </a>
                </li>
              ))}
            </ol>
            <a
              href="#topics"
              className="mt-4 inline-flex items-center gap-1 text-sm font-semibold text-primary-600 hover:text-primary-500"
            >
              查看更多实时热榜 <i className="ri-arrow-right-line"></i>
            </a>
          </div>

          <aside className="rounded-2xl bg-background-950 p-5 text-background-50">
            <div className="flex items-center justify-between">
              <h3 className="text-base font-bold">🌊 瓜友实时热评</h3>
              <span className="flex items-center gap-1.5 rounded-full bg-background-50/10 px-2 py-1 text-[11px]">
                <span className="h-1.5 w-1.5 rounded-full bg-secondary-400 animate-pulse"></span> 在线 1.2w
              </span>
            </div>
            <ul className="mt-4 flex flex-col gap-3">
              {liveComments.map((c, i) => (
                <li key={i} className="rounded-xl bg-background-50/[0.07] p-3">
                  <div className="flex items-center gap-2">
                    <span className="text-[11px] font-bold text-secondary-400">{c.name}</span>
                    <span className="rounded bg-accent-500/20 px-1.5 py-0.5 text-[10px] font-semibold text-accent-300">
                      {c.tag}
                    </span>
                  </div>
                  <p className="mt-1.5 text-xs leading-relaxed text-background-100">{c.text}</p>
                </li>
              ))}
            </ul>
            <a
              href="#treehole"
              className="mt-4 flex items-center justify-center gap-1 rounded-md bg-primary-500 py-2.5 text-sm font-bold text-background-50 transition hover:bg-primary-400"
            >
              加入实时讨论 <i className="ri-chat-smile-3-line align-middle"></i>
            </a>
          </aside>
        </div>
      </div>
    </section>
  );
}